<template>
    <div class="footer">
        <div class="seekAdviceFrom">
            <div class="seekAdviceFrom-cen">
                <h1>一键开启数字化增长新空间</h1>
                <div class="seekAdviceFrom-main">
                    <input type="text" placeholder="请输入你的手机号" v-model="number">
                    <button @click="changeSeekAdviceFrom">立即咨询</button>
                </div>
            </div>
        </div>
        <div class='fotContent'>
            <div class="fotContent-cen">
                <div class="fotContent-left">
                    <ul class="clearfloat">
                        <!-- <li>
                            <div>产品介绍</div>
                        </li> -->
                        <li>
                            <div>常见问题</div>
                            <p v-for="(entries, date,index) in data['常见问题']"  v-if="index < 4" :key="date" @click="openRenew(entries, date,'常见问题')">{{ date }}</p>
                            <p @click="openUrl('/productPrice')">产品价格</p>
                        </li>
                        <li>
                            <div>合作伙伴</div>
                            <p>丽水阀毕威阀门有限公司</p> 
                            <p>莲都区阀门协会</p> 
                            <p>丽水科科阀门有限公司</p> 
                            <p>华为</p> 
                        </li>
                        <li>
                            <div>关于我们</div>
                            <p @click="openUrl('/about')">公司简介</p>
                        </li>
                        <li>
                            <div>联系我们</div> 
                            <p>0578-2118573</p>
                            <p>15761416594</p>
                        </li>
                    </ul>
                </div>
                <div class='fotContent-right'>
                    <img src="../assets/code.png" alt="">
                    <img src="../assets/code.png" alt="">
                </div>
            </div>
        </div>
        <div class='copyright'>
            <div class="copyright-cen">
                <a href="http://beian.miit.gov.cn/">ICP证: 浙ICP备19006220号-3</a>
            </div>
        </div>
    </div>
</template>

<script>
import data from './content/renew.json'; // 根据实际路径导入 JSON 文件

export default {
  name: 'about',
  data () {
    return {
        number: '',
        data: data
    }
  },
  methods: {
    openUrl(url) {
        let urls = this.$router.resolve({
            path: url,
        });
        window.open(urls.href, "_blank");
    },
    isPhone(s) {
        const mobilePattern = /^(1[3-9])\d{9}$/; // 手机号码模式
        const landlinePattern = /^0\d{2,3}-\d{7,8}$/; // 座机号码模式
        
        return mobilePattern.test(s) || landlinePattern.test(s);
    },
    changeSeekAdviceFrom() {
        const h = this.$createElement;

        if (!this.isPhone(this.number)) {
            this.$message.error('请输入正确的手机号码')
            
            return
        }
        
        if(!this.number)return
        
        this.$http.post('/consultInfomationWebsite/saveConsultInfomation ',{telNumber:this.number}).then(res=>{
            if(res&&res.data.code===1000){
                this.number = ''
                this.$message.success('请保持电话畅通,稍后会有专员联系您')
            }
        }).catch(err=>{

        })
    },
    openRenew(entries,date,title) {
      let url = this.$router.resolve({
        path: '/contents',
        query: { title: title, details: JSON.stringify(entries), activeChild:date  }
      });
      window.open(url.href, '_blank');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
    /* background: #e6e6e6; */
    overflow: hidden;
}
.seekAdviceFrom {
    height: 340px;
    background: url(../assets/footer.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.seekAdviceFrom-cen {
    width: 1460px;
    height: 340px;
    margin: 0 auto;
    padding-top: 80px;
    box-sizing: border-box;
}
.seekAdviceFrom-cen h1 {
    font-weight: 500;
    font-size: 36px;
    color: #FFFFFF;
    text-align: center;
}

.seekAdviceFrom-main {
    width: 742px;
    margin: 40px auto 0;
    display: flex;
}

.seekAdviceFrom-main input {
    width: 584px;
    height: 56px; /* 确保输入框和按钮的高度一致 */
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #FFFFFF;
    border-radius: 2px;
    padding: 18px;
    box-sizing: border-box;
    outline: none;
    border-radius: 2px;
}

.seekAdviceFrom-main button {
    width: 158px;
    height: 56px;
    background: #2B77FF;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.seekAdviceFrom-main button:hover {
    background-color: #1a5bcc; /* 添加按钮悬停效果 */
}

.fotContent {
    background: #0F1D33;
    height: 307px;
}
.fotContent-cen {
    width: 1460px;
    margin: 0 auto;
    overflow: hidden;
}
.fotContent-left {
    float: left;
}
.fotContent-right {
    color: #999;
    float: right;
    padding-top:88px
}
.fotContent-right img {
    width: 120px;
}
.fotContent-right img:nth-child(2){
    margin-left: 50px;
}

.fotContent-left ul  {
    padding-top: 50px;
    box-sizing: border-box;
}
.fotContent-left ul li {
  color: #fff;
  float: left;
  margin-right: 118px;
}

.fotContent-left ul li div{
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 20px
}
.fotContent-left ul li p{
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 10px;
    cursor: pointer;
}


.copyright {
    height: 68px;
    background: #000000;
}
.copyright-cen {
    width: 1460px;
    margin: 0 auto;
    text-align: center;
}
.copyright-cen a {
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 68px;
}
</style>



// WEBPACK FOOTER //
// src/components/footers.vue